var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColMdOwnerPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 23,
    viewBox: "0 0 4 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43977 0.00300598H2.18694C1.49166 0.00300598 0.928024 0.454506 0.928024 1.01146V21.9906C0.928024 22.5476 1.49166 22.9991 2.18694 22.9991H2.43977C3.13505 22.9991 3.69869 22.5476 3.69869 21.9906V1.01146C3.69869 0.454506 3.13505 0.00300598 2.43977 0.00300598Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColMdOwnerPlay);
export default __webpack_public_path__ + "static/media/col_md_owner_play.2f2a92118d21b96a4177e7e4d867156c.svg";
export { ForwardRef as ReactComponent };